import { render } from "./home-sec3.vue?vue&type=template&id=1b07da47&scoped=true"
import script from "./home-sec3.vue?vue&type=script&lang=js"
export * from "./home-sec3.vue?vue&type=script&lang=js"

import "./home-sec3.vue?vue&type=style&index=0&id=1b07da47&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b07da47"]])

export default __exports__